var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"title":_vm.$t('确定发送此图片吗?'),"visible":_vm.visible},on:{"ok":_vm.handleOk,"cancel":_vm.handleCancel}},[_c('img',{staticStyle:{"max-width":"100%"},attrs:{"src":_vm.imgSrc}})])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }